import { getTimeString, TimeMode } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import {
  CustomParseFieldProps,
  ParseSetViewContext,
} from "@opendash/plugin-parse";
import { Button, Popconfirm, Typography } from "antd";
import React, { useContext } from "react";
type OrderCompleteFieldProps = CustomParseFieldProps<any>;
const OrderCompleteField = ({
  value,
  parseObject,
  setValue,
  fieldname,
  props,
}: OrderCompleteFieldProps) => {
  const t = useTranslation();
  const { state: TableState } = useContext(ParseSetViewContext);
  return (
    <>
      {parseObject && (
        <Popconfirm
          title={t("openware:mes.confirmOrderFinish")}
          onConfirm={() => {
            parseObject.set(
              "duration",
              Date.now() - parseObject.get("start").getTime()
            );
            parseObject.save().then(() => {
              TableState.data.reload();
            });
          }}
        >
          <div>
            <DurationButton
              disabled={parseObject.get("duration")}
              since={parseObject.get("start")}
              duration={parseObject.get("duration")}
            />
          </div>
        </Popconfirm>
      )}
      {!parseObject && "-"}
    </>
  );
};

type DurationButtonProps = React.PropsWithChildren & {
  since: number;
  duration?: number;
  disabled: boolean;
};
const DurationButton = (props: DurationButtonProps) => {
  const [tictac, setTictac] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTictac((draft) => draft + 1);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [tictac, setTictac, props.since]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        justifyContent: "center",
      }}
    >
      <Button
        icon={<Icon icon="fa:check"></Icon>}
        type="primary"
        disabled={props.disabled}
      >
        {getTimeString(
          TimeMode.DurationMode,
          "full",
          "ms",
          props.duration ? props.duration : Date.now() - props.since
        )}
      </Button>
      <Typography.Text type="secondary">
        {getTimeString(TimeMode.DateMode, "full", "ms", props.since)}
      </Typography.Text>
    </div>
  );
};

export default OrderCompleteField;
export type { OrderCompleteFieldProps };
